// src/auth/AuthContext.jsx
//
// Phase 2 Sprint 1: React Context value type for Firebase Auth.
// Per P5: this file exports ONLY the Context object.
// AuthProvider in separate file imports this Context.
// useAuth hook in separate file imports this Context.
// Prevents circular imports and duplicate context declarations.

import { createContext } from 'react';

export const AuthContext = createContext(null);
